module.exports = __webpack_public_path__ + "static/media/home-video-icon.02d19803.png";